<div *ngIf="openMeetingRoom" class="fixed w-screen h-full top-0 left-0 flex gap-5 z-[1000] p-5 bg-black/30">
  <div class="flex flex-1 flex-col items-center">
    <div id="jaas-container" class="flex-1 w-full max-w-screen-lg"></div>
    <button (click)="close()" class="mt-6 bg-blue-500 text-white w-fit py-2 px-4 rounded-lg hover:bg-blue-600">
      Sair do Atendimento
    </button>
  </div>
  <!-- Conteúdo ao lado da chamada (ex.: dados do paciente no atendimento) -->
  <ng-content></ng-content>
</div>
